import React from "react";

const Clients = () => {
  return (
    <div className="container mt-4">
      <style>{`
        .client-card { box-shadow:0 4px 15px rgba(0,0,0,0.08); border-radius:10px; }
      `}</style>

      <h4>Clients</h4>

      <div className="row">
        {[1,2,3,4,5,6].map(i => (
          <div key={i} className="col-md-4 mb-3">
            <div className="card p-3 client-card">
              <h6>Acme Corp</h6>
              <small>IT Services</small>

              <p className="small mt-2">
                📍 USA <br/>
                📧 mail@acme.com <br/>
                📞 +123456789
              </p>

              <div className="progress">
                <div className="progress-bar" style={{width:"65%"}}></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Clients;